import React from 'react'

import { IconButton } from 'components/uiKit/Button'
import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'
import { t } from 'services/Translation'

import * as s from './BrandGoBack.module.scss'

interface IFontGoBackProps {
  onClick?: () => void
  children?: React.ReactNode
}

const FontGoBack: React.FC<IFontGoBackProps> = ({ children, onClick }) => {
  return (
    <span className={s.root}>
      <IconButton
        icon='back20Px'
        iconSize={KitSize.S}
        name='mainMenuBackButton'
        onClick={onClick}
        size={KitSize.XS}
        styleType='ghost'
      />
      <Typography weight='semi'>{children || t('common.back')}</Typography>
    </span>
  )
}

export default FontGoBack
